<template>
  <div>
    <PageTitle
      title="Cash Book"
      :btnCreate="false"
      :permission="'Customer Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <v-btn :ripple="false" class="min-button" icon @click="show = !show">
        <v-icon color="blue" class="ml-10">
          {{ show ? 'mdi-filter' : 'mdi-filter-outline' }}
        </v-icon>
        <span class="subheading filterclor">Filter</span>
      </v-btn>
      <v-expand-transition>
        <v-card class="lighten-12 card-content" v-show="show">
          <div v-if="isShopSelected">
            <span class="shopAlert"> Shop is required</span>
          </div>
          <TableFilters
            :filters="[
              'dateRangebook',
              'shop',
              'search',
              'dateRange1',
              'ledgertype',
            ]"
            v-model="filter"
            :ShopVisible="true"
            :columns="false"
            :hasDate="true"
            :balance="balance"
            :changingBalance="total"
            :msgs="'Reference Number'"
            :filteredBalance="'Filtered Date Balance'"
            :filteredDate="'Filtered Date Range'"
          >
          </TableFilters>
        </v-card>
      </v-expand-transition>

      <ValidationObserver ref="observer" v-slot="{ validate, reset }">
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row v-if="editId == null">
              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Types"
                >
                  <v-autocomplete
                    hide-details="auto"
                    :error-messages="errors"
                    required
                    :items="types"
                    v-model="cashbook.type"
                    item-text="text"
                    item-value="value"
                    label="Type"
                    outlined
                    clearable
                    dense
                  ></v-autocomplete> </ValidationProvider
              ></v-col>
              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Amount"
                  vid="sortform"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    required
                    dense
                    label="Amount"
                    v-model="cashbook.amount"
                    outlined
                  ></v-text-field> </ValidationProvider
              ></v-col>

              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Ledger type"
                >
                  <v-autocomplete
                    :error-messages="errors"
                    required
                    hide-details="auto"
                    :items="ledger"
                    :loading="loadingLedger"
                    v-model="cashbook.ledger_type_id"
                    item-text="name"
                    item-value="id"
                    label="Ledger Type"
                    outlined
                    dense
                    clearable
                    @change="emitInput"
                    :search-input.sync="searchLedger"
                  ></v-autocomplete> </ValidationProvider
              ></v-col>

              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Comment"
                >
                  <v-text-field
                    :error-messages="errors"
                    required
                    dense
                    label="Comments"
                    v-model="cashbook.explanation"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="6" sm="6" lg="1">
                <permission-control permissionName="Unit Create">
                  <v-btn
                    @click="SaveUnit()"
                    depressed
                    small
                    :disabled="isDisabled"
                    class="text-white btn_blue btn_medium w-100"
                    >Create</v-btn
                  >
                </permission-control></v-col
              >
              <v-col
                cols="6"
                sm="6"
                lg="1"
                style="padding: 12px 20px 12px 43px"
              >
                <v-btn
                  @click="exportPDF()"
                  depressed
                  small
                  :disabled="isDisabled || ChequeData.length === 0"
                  class="text-white btn_medium w-100"
                  color="red"
                >
                  <v-icon small>mdi-file-pdf-box</v-icon>PDF</v-btn
                >
              </v-col>
              <v-col
                cols="6"
                sm="6"
                lg="1"
                style="padding: 12px 20px 12px 60px"
              >
                <v-btn
                  @click="exportExcel()"
                  depressed
                  small
                  :disabled="isDisabled || ChequeData.length === 0"
                  class="text-white btn_medium w-100"
                  color="green"
                  ><v-icon small>mdi-file-excel </v-icon>Excel</v-btn
                ></v-col
              >
            </v-row>

            <v-data-table
              :items-per-page="150"
              fixed-header
              :headers="columns"
              :items="ChequeData"
              item-key="id"
              hide-default-footer
              height="400px"
              id="indextable"
              style="font-family: 'Source Sans Pro', sans-serif"
            >
              <template v-slot:no-data>
                <noData
                  class="mt-5 container justify-center item-center"
                  name="cash book"
                />
              </template>
              <!-- No -->

              <template v-slot:item.no>
                <v-icon>mdi-vuetify</v-icon>
              </template>
              <!-- Reference No -->
              <template v-slot:item.reference_number="{ item }">
                <p>
                  {{
                    item.reference_number ? item.reference_number : '---------'
                  }}
                </p>
              </template>
              <!-- Shop -->

              <!-- date -->

              <template v-slot:item.date="{ item }">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Date"
                  v-if="item.id == editId"
                >
                  <DatePicker
                    :labelname="'Date'"
                    v-model="ChequeSingleData.date"
                  ></DatePicker>
                </ValidationProvider>
                <p v-else>
                  {{ item.date ? item.date : '---------' | formatDate }}
                </p>
              </template>
              >
              <!--Ledger Type-->
              <template v-slot:item.ledgerType="{ item }">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Ledger type"
                  v-if="item.id == editId"
                >
                  <v-autocomplete
                    :error-messages="errors"
                    required
                    hide-details="auto"
                    :items="ledger"
                    :loading="loadingLedger"
                    v-model="ChequeSingleData.ledgerType.id"
                    item-text="name"
                    item-value="id"
                    label="Ledger Type"
                    outlined
                    dense
                    clearable
                    @change="emitInput"
                    :search-input.sync="searchLedger"
                  ></v-autocomplete>
                </ValidationProvider>
                <p v-else>
                  {{ item.ledgerType ? item.ledgerType.name : '---------' }}
                </p>
              </template>
              <!--Ledger Type-->
              <!-- Type -->
              <template v-slot:item.type="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Type"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-autocomplete
                    hide-details="auto"
                    :error-messages="errors"
                    required
                    :items="types"
                    v-model="ChequeSingleData.type"
                    item-text="text"
                    item-value="value"
                    label="Type"
                    outlined
                    clearable
                    dense
                  ></v-autocomplete>
                </ValidationProvider>
                <p v-else>{{ item.type ? item.type : '---------' }}</p>
              </template>
              <!-- Amount -->
              <template v-slot:item.amount="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="amount"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-text-field
                    v-if="item.id == editId"
                    :error-messages="errors"
                    v-model="ChequeSingleData.amount"
                    :value="item.amount"
                    outlined
                    class="pt-3"
                  ></v-text-field>
                </ValidationProvider>
                <p v-else>
                  {{ item.amount | formatCurrency }}
                  <v-icon
                    v-if="item.type == 'Deposit'"
                    style="color: green"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-plus-box</v-icon
                  >
                  <v-icon
                    v-else
                    style="color: red"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-minus-box</v-icon
                  >
                </p>
              </template>

              <!-- Balnce -->
              <template v-slot:item.balance="{ item }">
                <p>
                  {{ item.balance | formatCurrency }}
                  <v-icon
                    v-if="item.balance > 0"
                    style="color: green"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-plus-box</v-icon
                  >
                  <v-icon
                    v-else
                    style="color: red"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-minus-box</v-icon
                  >
                </p>
              </template>

              <!-- Explanation -->
              <template v-slot:item.explanation="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Comments"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-text-field
                    v-if="item.id == editId"
                    :error-messages="errors"
                    v-model="ChequeSingleData.explanation"
                    :value="item.explanation"
                    outlined
                    class="pt-3"
                  ></v-text-field>
                </ValidationProvider>
                <p v-else>
                  {{ item.explanation ? item.explanation : '---------' }}
                </p>
              </template>
              <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="px-5">
                      <template>
                        <AuditLogs :Type="'cash_book'" :Typeid="item.id" />
                      </template>
                    </td>
                  </template> -->
              <!-- Action -->
              <template v-slot:item.action="{ item }">
                <v-menu offset-y transition="scroll-y-transition">
                  <template v-slot:activator="{ $attrs, on }">
                    <v-icon v-show="editId != item.id" v-bind="$attrs" v-on="on"
                      >mdi-dots-vertical</v-icon
                    >
                    <v-btn
                      v-show="editId == item.id"
                      color="secondary"
                      fab
                      x-small
                      dark
                      class="ma--2"
                    >
                      <v-icon depressed small link @click="CancelUnit(item)"
                        >clear</v-icon
                      ></v-btn
                    >
                    <v-btn
                      v-show="editId == item.id"
                      color="green"
                      fab
                      x-small
                      dark
                      ><v-icon link @click="UpdateChequeBook(item)"
                        >done</v-icon
                      ></v-btn
                    >
                  </template>

                  <v-list class="actions">
                    <permission-control permissionName="Unit Edit">
                      <v-list-item
                        link
                        @click="EditChequeBook(item)"
                        :disabled="isDisabled"
                      >
                        <span>
                          <v-icon v-bind="$attrs" v-on="on"
                            >mdi-pencil-box-outline</v-icon
                          >Edit
                        </span>
                      </v-list-item>
                    </permission-control>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:footer>
                <pagination
                  @paginationOptions="setPaginationOptions"
                  @responseData="receiveCashBookDatas"
                  @responseDataBalance="GetBalanceAmount"
                  @getPageNumber="setPagenumber"
                  url="cash-books"
                  :filter="filter"
                  :filterAction="true"
                  ref="pagination"
                />
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import DatePicker from '@/components/base/DateComponent.vue';
import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, email, max, regex } from 'vee-validate/dist/rules';
import { DateTime } from '@grapecity/wijmo';
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid Amount',
});
import pagination from '../../shared/components/pagination';
import TableFilters from '@/components/base/TableFilters';
import ChequeBook from '../../../models/chequeBook';
import * as moment from 'moment/moment';
import axios from '@/plugins/axios';
import jsPDF from 'jspdf';
import _ from 'lodash';
import XLSX from 'xlsx';
import noData from '../../../components/shared/noItem';
import { parse } from 'vue-currency-input';

export default {
  data: () => ({
    show: true,
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    ChequeData: [],
    ChequeSingleData: [],
    isShopSelected: false,

    // expanded: [],
    // singleExpand: false,
    Shops: [],
    ShopId: null,
    balance: null,
    cashbook: new ChequeBook(),
    paginationOptions: {},
    VisibleCreate: false,
    isDisabled: false,
    EditVisible: true,
    WareHouses: [],
    total: 0,
    columns: [
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Ledger Type',
        value: 'ledgerType',
        show: true,
        disabled: false,
        align: 'center',
      },

      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Balance',
        value: 'balance',
        show: true,
        disabled: false,
        align: 'right',
      },
      {
        text: 'Comments',
        value: 'explanation',
        show: true,
        disabled: false,
        align: 'center',
      },
      {
        text: 'Actions',
        value: 'action',

        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    types: [
      { text: 'Deposit', value: 'Deposit' },
      { text: 'Withdrawal', value: 'Withdrawal' },
    ],
    cash_book_for: [
      { text: 'Warehouse', value: 'Warehouse' },
      { text: 'Shop', value: 'Shop' },
    ],
    editId: null,
    filter: {
      search: '',
      shop: '',
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      end: '',
    },
    cashbook: {
      explanation: '',
      type: '',
      amount: 0,
    },
    selectionData: [],
    wareHouseLabel: '',
    searchLedger: null,
  }),
  components: {
    TableFilters,
    ValidationProvider,
    ValidationObserver,
    pagination,
    DatePicker,
    noData,
  },

  methods: {
    CancelUnit(item) {
      this.refreshData();
      this.editId = null;
    },

    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },

    //Get Pagination Datas
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    SaveUnit() {
      const isValid = this.$refs.observer.validate();

      if (isValid) {
        this.CreateChequeBook();
      }
    },

    refreshData() {
      this.$refs.pagination.refreshData();
    },

    sumField(array, type, field) {
      let value = 0;
      array.forEach((element) => {
        if (element[type] == 'Deposit') {
          value += parseFloat(element[field]);
        } else {
          value -= parseFloat(element[field]);
        }
      });
      return value;
    },

    // Get All XashBooks Data With Paginated
    receiveCashBookDatas(data) {
      let totalDeposit = 0;
      let totalWithdrawal = 0;
      this.ChequeData = data;
      this.ChequeData.forEach((element) => {
        const amount = parseFloat(element?.amount) || 0;

        if (element.type === 'Withdrawal') {
          totalWithdrawal += amount;
        } else {
          totalDeposit += amount;
        }
      });

      this.total = totalDeposit - totalWithdrawal;
    },
    // Get All CashBook Balance
    GetBalanceAmount(data) {
      this.balance = data;
    },
    //Update ChequeBook
    async UpdateChequeBook(item) {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        let Credential = this.ChequeSingleData;
        Credential.shop_id = this.ChequeSingleData.shop.id;
        Credential.ledger_type_id = this.ChequeSingleData.ledgerType.id;

        delete Credential.ledgerType;
        this.isDisabled = true;
        this.$store
          .dispatch(`book/EditChequeBook`, Credential)
          .then((res) => {
            this.editId = null;
            this.isDisabled = false;

            this.$toast.success('Cash book edited successfully.');

            this.refreshData();
            this.VisibleCreate = false;
            this.$refs.observer.reset();
            this.ChequeSingleData = [];
          })
          .catch((err) => {
            this.isDisabled = false;
            this.$toast.error('Failed to edit cash book.');
          });
      }
    },

    //edit ChequeBook
    EditChequeBook(item) {
      this.VisibleCreate = true;
      this.EditVisible = false;
      this.EditVisible = true;

      this.editId = item.id;

      this.$store
        .dispatch(`book/GetChequeBook`, item.id)
        .then((res) => {
          res.data.date = moment(res.data.date).format('YYYY-MM-DD');
          this.ChequeSingleData = res.data;
        })
        .catch((err) => {});
    },

    //Create ChequeBook
    async CreateChequeBook() {
      if (!this.filter.shop) {
        this.isShopSelected = true;
      } else {
        this.isShopSelected = false;

        let self = this;
        let credential = self.cashbook;
        credential.shop_id = self.filter.shop;
        credential.date = self.filter.startDate;

        this.isDisabled = true;
        this.$store
          .dispatch(`book/CreateChequeBook`, credential)
          .then((res) => {
            this.$toast.success('Cash book created successfully');
            this.isDisabled = false;

            this.refreshData();
            this.$refs.observer.reset();
            this.cashbook = new ChequeBook();
          })
          .catch((err) => {
            this.isDisabled = false;
            this.errormsgs = err;

            this.$toast.error('Failed to create cash book.');
          });
      }
    },

    //Get Shops Data
    getShopsData() {
      this.$store
        .dispatch(`shop/GetAllShopsDetails`)
        .then((res) => {
          this.Shops = res.data.data;
        })
        .catch((err) => {});
    },

    getLedgerByQuery(payload = '') {
      this.projectsLoading = true;
      let url = 'ledger-types/search?';
      if (payload != null && payload != undefined) {
        if (payload.query != '' && payload.query != null) {
          url += `query=${payload.query}&`;
        }
        if (payload.status != '' && payload.status != null) {
          url += `status=${payload.status}`;
        }
        if (
          payload.except != undefined &&
          payload.except != null &&
          payload.except.length > 0
        ) {
          url += `except=[${payload.except}]`;
        }
      }
      axios
        .get(url)
        .then((resp) => {
          this.ledger = resp.data.data;
          this.loadingLedger = false;
        })
        .catch((err) => {
          this.loadingLedger = false;
          this.messages = err.data.title;
        });
    },
    exportPDF() {
      let Data = _.cloneDeep(this.ChequeData);
      for (let x = 0; x < Data.length; x++) {
        Data[x].ledgerType = Data[x].ledgerType.name;
        Data[x].date = moment(Data[x].date).format('DD/MM/YYYY');
      }
      var rows = Data;
      var doc = jsPDF({
        orientation: 'landscape',
      });
      doc.setFontSize(14);
      // doc.setFontType("bold");
      doc.setTextColor(26, 26, 26);
      doc.setFont('helvetica', 'bold');
      doc.text('Cash Book Report', 15, 5);

      doc.setFontSize(11);
      doc.text(15, 12, `${moment(today).format('DD-MM-YYYY HH:MM:SS')}`);
      doc.text(200, 10, `Balance :- ${this.total.toFixed(2)}`);
      doc.autoTable(
        this.columns.map((h) => {
          if (h.text == 'Actions') {
            delete { title: h.text, dataKey: h.value };
          } else {
            return { title: h.text, dataKey: h.value };
          }
        }),
        rows,
        {
          didParseCell: function (data) {
            if (data.column.dataKey === 'addsress') {
              data.cell.text = data.cell.raw.country;
            }
          },
        },
      );
      const today = new DateTime();
      doc.save(`${moment(today).format('DD-MM-YYYY')}-Cash-Book.pdf`);
    },
    exportExcel() {
      var data = document.getElementById('indextable');
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format('DD-MM-YYYY'),
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format('DD-MM-YYYY')}-Cash-Book.xlsx`,
      );
    },
  },
  created() {
    this.getShopsData();
    this.getLedgerByQuery();
  },

  computed: {},
  watch: {
    searchLedger: {
      handler(val) {
        this.getLedgerByQuery(val);
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');

#indextable {
  max-height: 400px;
  overflow: auto;
}
.Balancebox {
  background: #ebf2ff;
  width: auto;
  color: #000000d4;
  align-items: center;
  text-align: center;
  height: 35px;
  margin-right: 0;
  border-radius: 6px;
}
.Balancebox2 {
  background: #ffebeb;
  width: auto;
  color: red;
  align-items: center;
  text-align: center;
  height: 35px;
  margin-right: 0;
  border-radius: 6px;
}
.createButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border-radius: 16px;
  background: #8796de !important;
  color: white;
  border: none;

  outline: none;
}
.EditButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border-radius: 16px;
  background: green !important;
  color: white;
  border: none;
  outline: none;
}
.UpdateButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border: none;
  outline: none;

  border-radius: 16px;
  background: purple !important;
  color: white;
}
.table-responsive {
  white-space: nowrap;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:last-child {
  padding-right: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:last-child {
  padding-right: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:first-child {
  padding-left: 0;
}

th {
  background: #feffff !important;
}

table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;

  border-spacing: 0;
}

.table {
  color: #333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table thead {
  background-color: #f8f9fa;
  border-bottom: 0px solid rgba(0, 0, 0, 0.03);
}

tr {
  display: table-row;

  border-color: inherit;
}

table.dataTable thead > tr > th.sorting_asc {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table.table-center th {
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 0px solid #dee2e6;
}

table.dataTable thead > tr > th.sorting {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}

th {
  text-align: inherit;
}

.table tbody tr {
  border-bottom: 0px solid rgba(0, 0, 0, 0.05);
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;

  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
}

h2 {
  font-family: 'Mada', sans-serif;
  margin-top: 0;
}

h2 {
  font-size: 2rem;
}

table.dataTable td {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table td {
  padding: 0.05rem;

  border-top: 0px solid #dee2e6;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;

  white-space: nowrap;
}

.shopAlert {
  color: red;
}
.min-button::before {
  display: none;
}
</style>
